import { RefObject, useCallback, useState } from 'react';
import { useResizeObserver } from 'src/modules/common/hooks/useResizeObserver.ts';

const isElementOverflowing = (element: HTMLElement) => (
    element.scrollWidth > element.clientWidth || element.scrollHeight > element.clientHeight
);

export const useIsOverflowing = (refs: RefObject<HTMLElement | null>[]) => {
    const [isOverflowing, setIsOverflowing] = useState(false);

    const checkOverflow = useCallback(() => {
        const elements = refs.map((ref) => ref.current).filter((el): el is HTMLElement => el !== null);
        setIsOverflowing(elements.some(isElementOverflowing));
    }, [refs]);

    useResizeObserver(refs, checkOverflow);

    return isOverflowing;
};
